import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContratarComponent } from 'src/app/app.components/colectivos/contratar/contratar.component';
import { MejorPrecioComponent } from 'src/app/app.components/colectivos/mejor-precio/mejor-precio.component';
import { PreguntasColectivoComponent } from 'src/app/app.components/colectivos/preguntas-colectivo/preguntas-colectivo.component';
import { SolicitudEnCursoComponent } from 'src/app/app.components/colectivos/solicitud-en-curso/solicitud-en-curso.component';
import { VerPrecioComponent } from 'src/app/app.components/colectivos/ver-precio/ver-precio.component';
import { CalcularSeguroComponent } from '../../app.components/colectivos/calcular-seguro/calcular-seguro.component';

const routes: Routes = [
    { path: 'ver-precio', component: VerPrecioComponent },
    { path: 'preguntas-colectivo', component: PreguntasColectivoComponent },
    { path: 'mejor-precio', component: MejorPrecioComponent },
    { path: 'contratar', component: ContratarComponent },
    { path: 'solicitud-en-curso', component: SolicitudEnCursoComponent },
    // tiene que ser la ultima para que no use ver-precio etc como un colectivo
    { path: ':colectivo', component: CalcularSeguroComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ColectivosRoutingModule { }
